import {
  ACC_RECONCILATION,
  ACC_SETUP,
  ACC_TYPE,
  COA,
  COST_CENTER,
  CREDIT_VOUCHER,
  CV_APPROVAL,
  DEBIT_VOUCHER,
  DV_APPROVAL,
  FINANCIAL_YEAR,
  GL_JOURNAL,
  GL_MAP,
  JOURNAL_VOUCHER,
  JV_APPROVAL,
  MY_REQUESTS,
  OPENING_BALANCE,
  PENDING_APPROVALS,
  PO_TRACKER,
  SUPPLIER_BILLS,
  REPORT_ACCOUNTS_LEDGER,
  REPORT_BALANCE_SHEET,
  REPORT_CASH_BANK_BOOK,
  REPORT_INCOME_STATEMENT,
  REPORT_MANAGER,
  REPORT_TRIAL_BALANCE,
  REPORT_VOUCHER_TXN,
  VOUCHER_APPROVAL_WORKFLOW,
} from '@constants/internal-route.constant'

// The feature urls under each sidebar group. A group renders only when the user holds at least one
// of them (SidebarMenuItemWithSub `anyOf`), so a role granted nothing in a group never sees an
// empty accordion. The groups do not follow the url prefixes: Chart of Accounts is /accounting/coa
// but sits in Settings.

export const VOUCHER_ROUTES = [CREDIT_VOUCHER, DEBIT_VOUCHER, JOURNAL_VOUCHER]

// The three per-type approval features. Holding any of them shows Pending Approvals
// (docs/ams-ui-alignment-plan.md, D2); the inbox offers only the held types.
export const APPROVAL_ROUTES = [CV_APPROVAL, DV_APPROVAL, JV_APPROVAL]

// The Approvals group (as stock's): My Requests for whoever raises vouchers, Pending Approvals for
// whoever approves them. It shows when either does; it is active on its own two screens.
export const APPROVALS_GROUP_ROUTES = [...VOUCHER_ROUTES, ...APPROVAL_ROUTES]
export const APPROVALS_GROUP_URLS = [MY_REQUESTS, PENDING_APPROVALS]

// Who may open a voucher's page (accounting.routes VOUCHER_VIEW): whoever raises or approves one.
// A report links a voucher number to that page only for them.
export const VOUCHER_VIEW_ROUTES = [...VOUCHER_ROUTES, ...APPROVAL_ROUTES]

export const BANK_GL_ROUTES = [ACC_RECONCILATION, GL_JOURNAL]

// Payables: Bills to Enter and Supplier Bills both ride on SUPPLIER_BILLS; the tracker is its own.
export const PAYABLES_ROUTES = [SUPPLIER_BILLS, PO_TRACKER]

// permission.helper ignores the link's query, so ?report=COA still matches the feature url.
export const REPORT_ROUTES = [
  `${REPORT_MANAGER}?report=COA`,
  REPORT_TRIAL_BALANCE,
  REPORT_BALANCE_SHEET,
  REPORT_INCOME_STATEMENT,
  REPORT_ACCOUNTS_LEDGER,
  REPORT_CASH_BANK_BOOK,
  REPORT_VOUCHER_TXN,
]

export const SETTINGS_ROUTES = [
  ACC_SETUP,
  COA,
  ACC_TYPE,
  FINANCIAL_YEAR,
  OPENING_BALANCE,
  COST_CENTER,
  GL_MAP,
  VOUCHER_APPROVAL_WORKFLOW,
]
